var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420.099,
    height: 512,
    viewBox: "0 0 420.099 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_110395",
    "data-name": "Group 110395",
    transform: "translate(-5870.937 8961.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110394",
    "data-name": "Group 110394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110393",
    "data-name": "Group 110393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110392",
    "data-name": "Group 110392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110389",
    "data-name": "Group 110389",
    transform: "translate(3 6.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149417",
    "data-name": "Path 149417",
    d: "M176,1c69.688,0,139.375,0,209.648.369,2.565,1,4.673,1.389,6.5,2.317,11.457,5.807,15.772,15.971,15.782,28.014q.158,196.231,0,392.461a37.545,37.545,0,0,1-1.68,11.008c-4.559,14.6-15.219,20.75-31.364,20.771q-139.735.182-279.473.016c-7.58-.006-15.157-.748-22.74-.929-13.542-.323-25.709-13.535-25.7-27.922q.079-146.236.028-292.472V130h5.377c28.664,0,57.329.138,85.991-.07,11.054-.08,20.462-4.818,27.9-12.822C174.4,108.355,177,97.319,176.938,85.746,176.795,57.5,176.333,29.249,176,1m82.5,263q-58.939,0-117.879.044a57.061,57.061,0,0,0-10.185,1.017c-5.017.927-10.277,9.1-9.1,13.721C123.269,286.325,128.025,290,135.9,290q67.68,0,135.361,0c20.313,0,40.626-.047,60.938.032,5.377.02,8.772-3.1,11.251-7.121s1.641-7.98-.949-12.165c-3.55-5.735-8.968-6.613-14.573-6.662-22.808-.2-45.619-.084-69.429-.084m-30-72q-46.452,0-92.9,0c-7.235,0-14.39,6.09-14.586,12.38-.207,6.665,6.934,13.59,14.357,13.594q97.648.062,195.3-.059c9.47-.023,13.932-6.626,14.22-13.565.231-5.542-7.531-12.574-14.491-12.5-33.629.338-67.263.152-101.895.152m-76,141c-5.993,0-12.019.392-17.971-.1-7.376-.608-12.824,6.647-13.4,12.615-.594,6.213,6.517,12.48,13.295,12.482,32.629.007,65.259-.106,97.888.079,8.2.046,13.69-5.982,13.555-12.777a13.172,13.172,0,0,0-13.463-12.4C206.108,333.173,179.8,333,152.5,333Z",
    transform: "translate(6335.008 -8455) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149419",
    "data-name": "Path 149419",
    d: "M127.469,513c-9.829-4.024-17.735-9.812-20-20.269C105.986,485.9,106.078,478.72,105.4,471h6q131.739,0,263.477-.055c12.432-.015,24.157-3.162,33.436-11.928,7.554-7.137,12.964-15.776,13.636-26.542.546-8.734.995-17.491,1-26.238Q423.055,235,423,63.768V58.061c9.816-.021,19.34-.878,28.154,3.6,10.325,5.251,15.782,13.86,15.8,25.387q.143,118.239.05,236.479c0,52.828-.11,105.658.071,158.486.051,14.751-6.316,24.739-19.974,30.632C340.646,513,234.292,513,127.469,513Z",
    transform: "translate(6335.008 -8455) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149420",
    "data-name": "Path 149420",
    d: "M151.572,1c7.457,2.544,9.7,7.438,9.585,14.925q-.613,38.487-.041,76.99c.154,10.9-10.812,22.018-22.238,22.057-25.831.089-51.663-.037-77.494.078-5.752.025-10.289-1.754-12.842-7.043-2.8-5.794-1.857-9.99,3.269-15.273,5.337-5.5,10.818-10.863,16.239-16.283q34.822-34.822,69.712-69.577c2.213-2.192,5.337-3.465,8.138-5.519A28.79,28.79,0,0,1,151.572,1Z",
    transform: "translate(6335.008 -8455) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67127",
    "data-name": "Rectangle 67127",
    width: 264,
    height: 210,
    transform: "translate(5974 -8833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110391",
    "data-name": "Group 110391",
    transform: "translate(542 57.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149411",
    "data-name": "Path 149411",
    d: "M100.189-455.15a6.8,6.8,0,0,0-3.212,2.633C96.3-451.236,96-439,96.2-412.452c.292,36.364.389,38.214,2.141,39.637l1.849,1.494H403.278l1.849-1.494c1.752-1.423,1.849-3.273,2.141-39.637.195-26.472-.1-38.784-.779-40.064a7.686,7.686,0,0,0-3.5-2.7C399.677-456.288,103.3-456.288,100.189-455.15Z",
    transform: "translate(5319.558 -8457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149412",
    "data-name": "Path 149412",
    d: "M101.915-319.029C95.672-316.821,96-322,96-220.446c0,67.29.329,93.975,1.2,95.7a9.253,9.253,0,0,0,4.163,3.456c1.972.672,26.071.96,79.2.768,73.173-.288,76.35-.384,78.54-2.112l2.3-1.824V-315.861l-2.3-1.824c-2.191-1.728-5.258-1.824-78.65-2.016C138.5-319.8,103.12-319.509,101.915-319.029Z",
    transform: "translate(5319.5 -8490.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149413",
    "data-name": "Path 149413",
    d: "M4.242.178A9.756,9.756,0,0,0,1.527,1.614C.085,2.571,0,4.9,0,32.52,0,61.991,0,62.4,1.782,63.7,3.478,64.932,5.769,65,63.8,65h60.236l2.036-1.915,2.036-1.915V3.87l-2.036-1.915L124.034.041H74.573C42-.028,4.921-.027,4.242.178Z",
    transform: "matrix(1, -0.017, 0.017, 1, 5597.977, -8809.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149421",
    "data-name": "Path 149421",
    d: "M4.242.178A9.756,9.756,0,0,0,1.527,1.614C.085,2.571,0,4.9,0,32.521,0,61.991,0,62.4,1.782,63.7,3.478,64.932,5.769,65,63.8,65h60.236l2.036-1.915,2.036-1.915V3.87l-2.036-1.915L124.034.041H74.573C64.018.019,52.991,0,42.583,0,21.792-.006,4.7.039,4.242.178Z",
    transform: "matrix(1, -0.017, 0.017, 1, 5597.703, -8724.395)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.8d6c5fb3c6347cf57cebeb8046e766c3.svg";
export { ForwardRef as ReactComponent };